module.exports = __webpack_public_path__ + "img/headercopy.25be9a7f.svg";